import React from "react";
import PropTypes from "prop-types";
import { FormGroup, Col, ControlLabel} from "react-bootstrap";
import Select from "react-select";

const PackageArea = (props) =>(
	<Col md={6} sm={12} >
		<FormGroup>
			<ControlLabel>{props.item && props.item.label}</ControlLabel>
			<Select.Async
				onChange={(option) => { props.onPackageAsyncChange(option, props.index); }}
				name={props.task && props.task.full_name}
				placeholder="Search user"
				value={props.task && props.task.user_id && {id: props.task.user_id, full_name: props.task.full_name}}
				disabled={props.disabled}
				labelKey="full_name"
				valueKey="id"
				loadOptions={(e,c)=>props.handleAsyncSearch(e,"user","roles=2,4",c)}
				clearable={false}
				multi={false}
			/>
		</FormGroup>
	</Col>
); 

PackageArea.defaultProps = {
	errors: PropTypes.object,
	disabled: false,
	onPackageAsyncChange: PropTypes.func
};

PackageArea.propTypes = {
	disabled: PropTypes.bool,
	item: PropTypes.shape({
		id: PropTypes.number,
		label: PropTypes.string,
		user_id: PropTypes.string,
	}).isRequired,
	index: PropTypes.number.isRequired,
	task:PropTypes.shape({
		area_package_id:PropTypes.number,
		user_id:PropTypes.string,
		full_name:PropTypes.string,
	}).isRequired,
	onPackageAsyncChange: PropTypes.func,
	handleAsyncSearch: PropTypes.func.isRequired
};

export default PackageArea;


// WEBPACK FOOTER //
// ./src/components/forms/projects/partials/PackageArea.js